// extracted by mini-css-extract-plugin
export default {"word":"LabelLayout_word__VdS8s"};